import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Button } from 'app/shared/button';
import { MultiSelect } from 'app/shared/select';
import { useCurrencyService } from 'hooks/api/sales/currency';
import { useSubscriptionService } from 'hooks/api/sales/subscriptions';
import React, { useEffect, useState } from 'react';
import { InvoiceItemRow } from './item';
import { useInvoiceService } from 'hooks/api/sales/invoice';
import styles from './invoice.module.css';
import { Spacer } from 'app/member/layouts/generic';

export const InvoiceGeneration = ({ tenant }) => {
  const { fetchCurrencies } = useCurrencyService();
  const { generateInvoice } = useInvoiceService();
  const { fetchSubscriptions } = useSubscriptionService();

  const [currencies, setCurrencies] = useState([]);
  const [existing_subscriptions, setExistingSubscriptions] = useState([]);
  const [has_subscription, setHasSubscription] = useState(false);
  const [selected_currency, setSelectedCurrency] = useState({});
  const [items, setItems] = useState([]);

  const [is_saving, setIsSaving] = useState(false);
  const [file_location, setFileLocation] = useState(null);

  useEffect(() => {
    if (!tenant.id) return;

    // Reset state when tenant changes
    setItems([]);
    setFileLocation(null);

    fetchCurrencies().then(({ currencies }) => {
      const parsed_currencies = currencies.map((cur) => ({
        ...cur,
        label: cur.code,
        value: cur.code
      }));
      setCurrencies(parsed_currencies);
      setSelectedCurrency(parsed_currencies[0] || {});
    });

    fetchSubscriptions({ query_string: `tenant_id=${tenant.id}&status=active` }).then(
      ({ subscriptions }) => {
        setHasSubscription(subscriptions.length > 0);
      }
    );

    fetchSubscriptions({ query_string: `tenant_id=${tenant.id}` }).then(({ subscriptions }) => {
      setExistingSubscriptions(subscriptions);
    });
  }, [tenant.id]);

  const addItemRow = () => {
    setItems([...items, { key: Date.now() }]);
  };

  const handleItemChange = (key, updated_item) => {
    setItems(items.map((item) => (item.key === key ? updated_item : item)));
  };

  const removeItemRow = (key) => {
    setItems(items.filter((item) => item.key !== key));
  };

  const submit = async () => {
    setIsSaving(true);
    const data = { items, currency: selected_currency.value, tenant };
    try {
      const { location } = await generateInvoice({ data });
      setFileLocation(location);
      setIsSaving(false);
    } catch (error) {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <GridRow num_of_columns={5}>
        <GridColumn span={4} />
        <GridColumn>
          <MultiSelect
            options={currencies}
            value={selected_currency}
            onChange={setSelectedCurrency}
          />
        </GridColumn>
      </GridRow>
      <Spacer multiple={4} />
      {file_location && (
        <GridRow num_of_columns={1}>
          <GridColumn>
            <div className={styles.fileLocation}>
              <a href={file_location} target="_blank" rel="noopener noreferrer">
                Download Invoice
              </a>
            </div>
            <Spacer multiple={4} />
          </GridColumn>
        </GridRow>
      )}
      {items.map((item, index) => (
        <InvoiceItemRow
          item={item}
          currency={selected_currency.value}
          existing_subscriptions={existing_subscriptions}
          has_subscription={has_subscription}
          key={index}
          onChange={handleItemChange}
          onRemove={removeItemRow}
        />
      ))}
      <GridRow num_of_columns={3}>
        <GridColumn />
        <GridColumn>
          <Button text="Add Item" type="secondary" onClick={addItemRow} />
        </GridColumn>
        <GridColumn>
          <Button
            loading={is_saving}
            disabled={is_saving}
            text="Generate Invoice"
            onClick={submit}
          />
        </GridColumn>
      </GridRow>
    </div>
  );
};
